import {Component, ElementRef, Inject, OnInit, ViewChild} from '@angular/core';
import {LoadingController, ModalController, Platform, ToastController} from '@ionic/angular';
import * as actionsUi from './mandantenverwaltung-einstellungen.actions.ui';
import * as fromAuthModule from '@orga-app/auth/reducer';
import * as fromMandantModule from '@orga-app/mandant/reducer';
import * as fromMandantenverwaltungPage from './mandantenverwaltung-einstellungen.reducer';
import {select, Store} from '@ngrx/store';
import {Observable} from 'rxjs';
import {DOCUMENT} from '@angular/common';
import {Settings, SettingsProvider} from '@orga-app/settings';
import {
    getIncidentAnzeigeConfig,
    getLizenzConfig, getMandantConfigFehler, getMandantConfigLaden,
    getMandantInfo,
    getMandantLogo,
    getMandantLogoLaden,
    getPandemieConfig,
    getStammConfig,
    getVeranstaltungenConfig,
    getVorlagenConfig
} from './mandantenverwaltung-einstellungen.selectors';
import {ImageService} from '@orga-app/providers/image.service';
import {DomSanitizer, SafeUrl} from '@angular/platform-browser';
import {getTheme} from '@orga-app/settings/reducer';
import {getIstPandemieLizenzAktiv, getPandemieMandantOptions} from '@orga-app/mandant/reducer';
import {DocumentService} from '@orga-app/providers/document.service';
import {VorlagenMandantOptions} from '@orga-app/clients/vorlagen';
import {UuidService} from '@orga-app/providers/uuid.service';
import {Bild, LizenzMandantOptions, MandantInfo, MandantStammOptions, UploadResponse, UploadService} from '../../../clients/api';
import {VeranstaltungenMandantOptions} from '../../../clients/veranstaltungen';
import {PandemieMandantOptions} from '../../../clients/pandemie';
import {IncidentsAnzeigeMandantOptions} from '../../../clients/incidents';
import {JsonEditorPage} from '../modale/json-editor/json-editor.page';

declare let themesJson;

@Component({
    selector: 'page-mandantenverwaltung',
    templateUrl: './mandantenverwaltung-einstellungen.page.html',
})
export class MandantenverwaltungEinstellungenPage implements OnInit {
    @ViewChild('logoFileInput', {static: false, read: ElementRef}) logoFileInput: ElementRef;

    selectedTheme: Settings;
    public settings$: Observable<Settings>;
    themeDefault$: Observable<Settings>;
    logoHeaderSVG$: Observable<SafeUrl>;

    themes = themesJson;
    private aiName = 'MandantenverwaltungEinstellungenPage';
    private alive = true;

    public istPandemieLizenzAktiv$: Observable<boolean>;

    public stammConfig$: Observable<MandantStammOptions>;
    public lizenzConfig$: Observable<LizenzMandantOptions>;
    public mandantInfo$: Observable<MandantInfo>;
    public vorlagenConfig$: Observable<VorlagenMandantOptions>;
    public veranstaltungenConfig$: Observable<VeranstaltungenMandantOptions>;
    public pandemieConfig$: Observable<PandemieMandantOptions>;
    public incidentAnzeigeConfig$: Observable<IncidentsAnzeigeMandantOptions>;

    public mandantConfigLaden$: Observable<boolean>;
    public mandantConfigFehler$: Observable<boolean>;

    public mandantLogo$: Observable<Bild>;
    public mandantLogoLaden$: Observable<boolean>;

    public pandemieMandantOptions$: Observable<PandemieMandantOptions>;

    innererTab2 = 'Allgemein';

    constructor(public modalCtrl: ModalController,
                private store: Store<fromMandantenverwaltungPage.PageState>,
                private storeAuth: Store<fromAuthModule.ModuleState>,
                private storeMandant: Store<fromMandantModule.ModuleState>,
                public platform: Platform,
                private settings: SettingsProvider,
                private uploadCommandService: UploadService,
                public loadingCtrl: LoadingController,
                private documentService: DocumentService,
                private imageService: ImageService,
                public settingsProvider: SettingsProvider,
                private uuid: UuidService,
                public element: ElementRef,
                private sanitizer: DomSanitizer,
                public toastCtrl: ToastController,
                @Inject(DOCUMENT) private document: Document) {
        this.store.dispatch(new actionsUi.PageStateResetAction());

        this.istPandemieLizenzAktiv$ = this.storeMandant.pipe(select(getIstPandemieLizenzAktiv));
        this.pandemieMandantOptions$ = this.storeMandant.pipe(select(getPandemieMandantOptions));

        this.themeDefault$ = this.settingsProvider.getThemeDefault();
        this.logoHeaderSVG$ = this.settingsProvider.getLogoHeaderSVG();
        this.settings$ = this.store.pipe(select(getTheme));
        this.settings.getActiveTheme().subscribe(val => this.selectedTheme = val);

        this.stammConfig$ = this.store.pipe(select(getStammConfig));
        this.lizenzConfig$ = this.store.pipe(select(getLizenzConfig));
        this.mandantInfo$ = this.store.pipe(select(getMandantInfo));
        this.vorlagenConfig$ = this.store.pipe(select(getVorlagenConfig));
        this.veranstaltungenConfig$ = this.store.pipe(select(getVeranstaltungenConfig));
        this.pandemieConfig$ = this.store.pipe(select(getPandemieConfig));

        this.mandantLogo$ = this.store.pipe(select(getMandantLogo));
        this.mandantLogoLaden$ = this.store.pipe(select(getMandantLogoLaden));

        this.incidentAnzeigeConfig$ = this.store.pipe(select(getIncidentAnzeigeConfig));

        this.mandantConfigLaden$ = this.store.pipe(select(getMandantConfigLaden));
        this.mandantConfigFehler$ = this.store.pipe(select(getMandantConfigFehler));
    }

    ngOnInit() {
    }

    ionViewWillEnter() {
        this.store.dispatch(new actionsUi.PageStateResetAction());
    }

    stammConfigEingabe($event, stammConfig: MandantStammOptions, propName: string, propTyp: string) {
        this.store.dispatch(new actionsUi.StammConfigInput(this.dokumentAendernInput($event, stammConfig, propName, propTyp)));
    }

    vorlagenConfigEingabe($event, stammConfig: VorlagenMandantOptions, propName: string, propTyp: string) {
        this.store.dispatch(new actionsUi.VorlagenConfigInput(this.dokumentAendernInput($event, stammConfig, propName, propTyp)));
    }

    async einstellungenSpeichern() {
        this.store.dispatch(new actionsUi.MandantenEinstellungenSpeichern());
        const toast = await this.toastCtrl.create({
            message: 'Die Einstellungen wurden versendet, bitte mit F5 die Seite neu laden.',
            duration: 2000
        });
        await toast.present();
    }

    dokumentAendernInput<T>($event, dokument: T, propName: string, propTyp: string): T {
        // console.log('event1: ', $event.detail);

        if (propName !== null) {
            if (propTyp === 'date') {
                // DATE
                dokument = Object.assign({}, dokument, {[propName]: this[propName]});
            } else if (propTyp === 'checkbox') {
                // Checkbox
                dokument = Object.assign({}, dokument, {[propName]: $event.detail.checked});
            } else if (propTyp === 'toggle') {
                // Toggle
                dokument = Object.assign({}, dokument, {[propName]: $event.detail.checked});
            } else if (propTyp === 'input') {
                // Input
                dokument = Object.assign({}, dokument, {[propName]: $event.target.value});
            } else if (propTyp === 'value') {
                // Value
                dokument = Object.assign({}, dokument, {[propName]: $event});
            } else {
                // SELECT
                dokument = Object.assign({}, dokument, {[propName]: $event.detail.value});
            }
        }

        return dokument;
    }

    async bildAuswahlen(stammConfig: MandantStammOptions) {
        this.logoFileInput.nativeElement.click();
    }

    async bildEinfuegen(stammConfig: MandantStammOptions) {
        const fi = this.logoFileInput.nativeElement;
        if (fi.files && fi.files[0]) {
            const fileToUpload = fi.files[0];

            const loading = await this.loadingCtrl.create({
                spinner: 'dots',
                message: 'Das Logo wird hochgeladen ...',
                translucent: true,
                backdropDismiss: false,
                keyboardClose: true
            });

            await loading.present();
            this.uploadCommandService.postUploadForm(fileToUpload, `logos`).subscribe((result: UploadResponse) => {
                stammConfig = Object.assign({}, stammConfig, {'logo_id': result.upload_id});
                loading.dismiss();
                this.store.dispatch(new actionsUi.StammConfigInput(stammConfig));
            }, error2 => {
            });
        }
    }

    async jsonEditorPandemieLevelOeffnen(object: PandemieMandantOptions) {
        if (object != null) {
            const params = {
                json: JSON.stringify(object.level),
                untertitel: 'Pandemie-Level'
            };
            const modal = await this.modalCtrl.create({component: JsonEditorPage, componentProps: params});
            modal.onDidDismiss().then((result: any) => {
                if (result != null && result.data) {
                    const config = Object.assign({}, object, {level: JSON.parse(result.data.json)});
                    this.store.dispatch(new actionsUi.PandemieConfigInput(config));
                }
            });

            await modal.present();
        }
    }

    incidentAnzeigeConfigEingabe($event, incidentAnzeigeConfig: IncidentsAnzeigeMandantOptions, propName: string, propTyp: string) {
        this.store.dispatch(new actionsUi.IncidentAnzeigeConfigInput(this.dokumentAendernInput($event, incidentAnzeigeConfig, propName, propTyp)));
    }
}
